import { defineMessages } from "react-intl";

export default defineMessages({
  subtotal: {
    id: 'subtotal',
    defaultMessage: 'subtotal'
  }
});